

  <div class="copyright-text">
    <span>{{ copyrightLabel() }}</span>
  </div>
   <span class="copyright-text-temp">
    <span>© {{year()}} </span>
    <span class="copyright-title" lang="{{translate.currentLang}}"></span>
  </span>
<!-- copyright-title[lang~=fr]::after {
  content: "2026 — Harvest Music Festival - Tous droits réservés";
}
.copyright-title[lang~=en]::after {
  content: "2026 — Harvest Music Festival - All Rights Reserved";
} -->